export const RETRY_TIME_IN_MILLISECONDS = 10000;
